import { SendOutlined } from "@ant-design/icons";
import React, { useState, useRef } from "react";
import TimeShower from "../../../../components/TimeShower";
import { IconBtn } from "../../../chat/footer/Footer";
import VoiceInput from "../../../chat/footer/VoiceInput";
import TextInput from "./TextInput";
import { SessionStatus } from "../../../../constant/Types";

export const SendType = {
  free: "free",
  text: "text",
  voice: {
    recoding: "voice-recoding", // start
    hold: "voice-hold",
    fixed: "voice-fixed", // open popup
    send: "voice-send",
    cancel: "voice-cancel",
  },
};

const ChatFooter = ({
  sendMessageHandler,
  setSendType,
  sendType,
  consultationStatus,
}) => {
  const [voiceTime, setVoiceTime] = useState(0);

  const inputRef = useRef();

  const isChatDisabled =
    consultationStatus === SessionStatus.CLOSED ||
    consultationStatus === SessionStatus.CLOSED_BY_ADMIN;

  function sendMessage(messageType, messageData, options) {
    sendMessageHandler(messageType, messageData, options);
  }

  const handleSubmitText = () => {
    inputRef.current.submit();
  };


  return (
    <>
      <div className={"chat-footer"}>
        <div
          className={`chat-box-holder center-flex  ${
            isChatDisabled ? `chat-disabled-rate` : ``
          }`}
        >
          <div
            className={`chat-input-holder ${
              sendType === SendType.voice.recoding
                ? "voice-recording center-flex"
                : ""
            }`}
          >
            {(sendType === SendType.free || sendType === SendType.text) && (
              <TextInput
                ref={inputRef}
                sendMessage={sendMessage}
                sendType={sendType}
                setSendType={setSendType}
              />
            )}

            {sendType === SendType.voice.recoding && (
              <div className={`record-time unselectable`}>
                <TimeShower time={voiceTime ? voiceTime : 0} />
              </div>
            )}
          </div>
          <div className="buttons-holder unselectable">
            {sendType === SendType.text ? (
              <IconBtn
                className={"btn-send-input test"}
                icon={<SendOutlined />}
                onClick={handleSubmitText}
              />
            ) : (
              <VoiceInput
                voiceTime={voiceTime}
                setVoiceTime={setVoiceTime}
                setSendType={setSendType}
                sendType={sendType}
                sendMessage={sendMessage}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatFooter;
